/**************  CSS  **************/
import './ProgressBar.css'

/**********  React hooks  **********/

/**********  Components  ***********/


/************  Others  *************/

export default function ProgressBar({actual, total}) {
    var width = actual / total * 100

    if(width > 100) {
        width = 100;
    }
    else if(width < 0) {
        width = 0;
    }

    return <div className='tda-ProgressBar'>
        <div className='bar' style={{width: width + '%'}} />
    </div>
}